/* TWRD 2026-10-22: "Keep shopping for" (sections/twrd-keep-shopping.liquid).
   History lives only in this visitor's browser, localStorage twrd_recent:
     { p: [{ h: handle, f: family handle, ft: family title, t: time }],  max 20
       s: [{ q: query, t: time }] }                                      max 10
   Read and written ONLY with preferences consent
   (Shopify.customerPrivacy.preferencesProcessingAllowed()). No consent, no
   storage, no module. */
(function () {
  'use strict';
  if (window.__twrdRecent) return;
  window.__twrdRecent = true;

  var KEY = 'twrd_recent';
  var MAX_P = 20;
  var MAX_S = 10;
  var ctx = window.twrdRecentCtx || {};

  function allowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    /* Region guard in snippets/twrd-consent.liquid: unknown region counts as no consent. */
    try { if (window.twrdConsent && typeof window.twrdConsent.held === 'function' && window.twrdConsent.held()) return false; } catch (_) { return false; }
    try { return !!(cp && typeof cp.preferencesProcessingAllowed === 'function' && cp.preferencesProcessingAllowed() === true); }
    catch (_) { return false; }
  }
  /* Shared with assets/twrd-search-overlay.js (twrd_recently_viewed), so both
     browser stores follow the same consent rule. */
  window.twrdRecentAllowed = allowed;
  function read() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || '{}');
      return { p: Array.isArray(d.p) ? d.p : [], s: Array.isArray(d.s) ? d.s : [] };
    } catch (_) { return { p: [], s: [] }; }
  }
  function write(d) {
    try { localStorage.setItem(KEY, JSON.stringify({ p: d.p.slice(0, MAX_P), s: d.s.slice(0, MAX_S) })); } catch (_) {}
  }
  function addProduct(h, f, ft) {
    if (!h) return;
    var d = read();
    d.p = [{ h: h, f: f || '', ft: ft || '', t: Date.now() }].concat(d.p.filter(function (x) { return x.h !== h; }));
    write(d);
  }
  function addSearch(q) {
    q = String(q || '').trim().slice(0, 60);
    if (!q) return;
    var d = read();
    var low = q.toLowerCase();
    d.s = [{ q: q, t: Date.now() }].concat(d.s.filter(function (x) { return String(x.q).toLowerCase() !== low; }));
    write(d);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function img(url, w) {
    if (!url) return '';
    var u = String(url);
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  /* Collection titles can be in caps (BLACK & WHITE): show them in title case. */
  function titleCase(s) {
    return String(s).toLowerCase().replace(/(^|\s)(\S)/g, function (m, a, b) { return a + b.toUpperCase(); });
  }

  /* Tiles, newest first, max 3: families with 2+ viewed products, recent searches. */
  function tiles() {
    var d = read();
    var fam = {};
    d.p.forEach(function (x) {
      if (!x.f) return;
      var e = fam[x.f] || (fam[x.f] = { kind: 'family', key: x.f, title: titleCase(x.ft || x.f), n: 0, t: 0 });
      e.n += 1;
      if (x.t > e.t) e.t = x.t;
    });
    var out = Object.keys(fam).map(function (k) { return fam[k]; }).filter(function (e) { return e.n >= 2; });
    d.s.forEach(function (x) { out.push({ kind: 'search', key: x.q, title: x.q, t: x.t }); });
    out.sort(function (a, b) { return b.t - a.t; });
    return out.slice(0, 3);
  }

  function images(tile) {
    var url = tile.kind === 'family'
      ? '/collections/' + encodeURIComponent(tile.key) + '/products.json?limit=6'
      : '/search/suggest.json?q=' + encodeURIComponent(tile.key) + '&resources[type]=product&resources[limit]=6';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var list = [];
      if (j && j.products) list = j.products.map(function (p) { return p.images && p.images[0] && p.images[0].src; });
      else if (j && j.resources && j.resources.results && j.resources.results.products) list = j.resources.results.products.map(function (p) { return p.featured_image && p.featured_image.url || p.image; });
      return list.filter(Boolean).slice(0, 3);
    }).catch(function () { return []; });
  }

  function render(root) {
    var list = root.querySelector('[data-twrd-keep-list]');
    var ts = tiles();
    if (!list || !ts.length) { root.hidden = true; return; }
    Promise.all(ts.map(images)).then(function (imgs) {
      var html = '';
      ts.forEach(function (t, i) {
        var pics = imgs[i];
        if (!pics.length) return;
        var href = t.kind === 'family' ? '/collections/' + encodeURIComponent(t.key) : '/search?q=' + encodeURIComponent(t.key) + '&type=product';
        var line = t.kind === 'family' ? t.n + ' viewed' : 'Recent search';
        var label = t.kind === 'family' ? 'Keep shopping ' + t.title + ', ' + t.n + ' viewed' : 'Search again for ' + t.title;
        html += '<li class="twrd-keep__item"><a class="twrd-keep__tile" href="' + href + '" aria-label="' + esc(label) + '">' +
          '<span class="twrd-keep__mosaic">' +
          '<span class="twrd-keep__big"><img src="' + esc(img(pics[0], 600)) + '" alt="" loading="lazy" width="600" height="750"></span>' +
          '<span class="twrd-keep__small">' +
          (pics[1] ? '<img src="' + esc(img(pics[1], 300)) + '" alt="" loading="lazy" width="300" height="375">' : '<span class="twrd-keep__blank"></span>') +
          (pics[2] ? '<img src="' + esc(img(pics[2], 300)) + '" alt="" loading="lazy" width="300" height="375">' : '<span class="twrd-keep__blank"></span>') +
          '</span></span>' +
          '<span class="twrd-keep__name">' + esc(t.title) + '</span>' +
          '<span class="twrd-keep__line">' + esc(line) + '</span>' +
          '</a></li>';
      });
      if (!html) { root.hidden = true; return; }
      list.innerHTML = html;
      root.hidden = false;
    });
  }

  function boot() {
    if (!allowed()) return false;
    if (ctx.type === 'product') addProduct(ctx.handle, ctx.family, ctx.familyTitle);
    if (ctx.type === 'search') addSearch(ctx.q);
    Array.prototype.forEach.call(document.querySelectorAll('[data-twrd-keep-shopping]'), render);
    return true;
  }

  /* Predictive search and any search form: record the query on submit. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || String(f.action).indexOf('/search') < 0 || !allowed()) return;
    var q = f.querySelector('input[name="q"]');
    if (q) addSearch(q.value);
  }, true);

  /* Clear: wipe the key, hide the module. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-twrd-keep-clear]');
    if (!b) return;
    e.preventDefault();
    try { localStorage.removeItem(KEY); } catch (_) {}
    var root = b.closest('[data-twrd-keep-shopping]');
    if (root) root.hidden = true;
  });

  var booted = false;
  function tryBoot() { if (!booted) booted = boot(); }
  if (document.readyState === 'complete') tryBoot();
  else window.addEventListener('load', tryBoot);
  /* Consent may arrive later (banner) or the API may load after us. */
  document.addEventListener('visitorConsentCollected', function () { setTimeout(tryBoot, 0); });
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { tryBoot(); });
  }
})();
